import Header from "@components/common/Header/index";
import LeftNavigation from "@components/common/LeftNavigation/index";
import { getValue } from "@utils/lodash";
import "./dashboard.scss";
import { useEffect, useState } from "react";
import { useNavigation } from "@components/common/LeftNavbar/NavigationContext";
import { useLocation } from "react-router-dom";
import { allNavigationMenu } from "@components/common/LeftNavbar/PermissionJSON";

function optimizeNavigationMenus(
  navigationMenu: any,
  permissions: string[],
  subTabPermissionList: string[],
): any {
  let mainMenu =
    getValue(navigationMenu, `length`, 0) > 0 &&
    navigationMenu.filter((item: any) =>
      permissions.includes(getValue(item, `name`, "")),
    );
  let checkChildrensPermission =
    getValue(mainMenu, `length`, 0) > 0 &&
    mainMenu.map((menuItem: object) => {
      let menus =
        getValue(menuItem, `menu.length`, 0) > 0 &&
        getValue(menuItem, `menu`, []).map((item: object) => {
          let childrens =
            getValue(item, `childrens.length`, 0) > 0 &&
            getValue(item, `childrens`, []).filter(
              (child: object) =>
                subTabPermissionList.includes(getValue(child, `name`, "")),
              // [...subTabPermissionList, "audit_mis_reports"].includes(
              //   getValue(child, `name`, ""),
              // ),
            );
          if (getValue(item, `childrens.length`, 0) > 0) {
            return {
              ...item,
              childLink: getValue(childrens, `[${0}].link`, ""),
              name: getValue(childrens, `[${0}].name`, ""),
              childrens: childrens,
            };
          } else {
            return {
              ...item,
              childLink: getValue(item, `link`, ""),
            };
          }
        });
      return {
        ...menuItem,
        menu: menus,
      };
    });

  let checkMenuPermission =
    getValue(checkChildrensPermission, `length`, 0) > 0 &&
    checkChildrensPermission.map((menuItem: object) => {
      let menus =
        getValue(menuItem, `menu.length`, 0) > 0
          ? getValue(menuItem, `menu`, []).filter(
              (item: object) =>
                subTabPermissionList.includes(getValue(item, `name`, "")),
              // [...subTabPermissionList, "audit_mis_reports"].includes(
              //   getValue(item, `name`, ""),
              // ),
            )
          : [];

      return {
        ...menuItem,
        menu: menus,
      };
    });
  return getValue(checkMenuPermission, `length`, 0) > 0
    ? checkMenuPermission.map((item: object) => ({
        ...item,
        childLink: getValue(item, `menu[${0}].childLink`, ""),
      }))
    : [];
}

export default function DashboardLayout(props: any) {
  let location = useLocation();
  const {
    clientNavigation,
    setClientNavigation,
    clientMoreNavigation,
    setClientMoreNavigation,
    setIsLoading,
    isOpenFirstLevel,
    isOpenSecondLevel,
    toggleFirstLevel,
    toggleSecondLevel,
    setIsOpenFirstLevel,
    setIsOpenSecondLevel,
    selectedDynamicTab,
    selectedDynamicTabKey,
    setSelectedDynamicTabKey,
    dynamicNavigation,
    setDynamicNavigation,
  } = useNavigation();

  useEffect(() => {
    const clientNav = optimizeNavigationMenus(
      allNavigationMenu,
      props.permissions,
      props.subTabPermissionList,
    );
    let filtered = clientNav.filter(
      (item: object) => getValue(item, `name`, "") !== selectedDynamicTabKey,
    );

    let nav1 = filtered.filter((_item: object, index: number) => index < 4);
    let nav2 = filtered.filter((_item: object, index: number) => index > 3);
    let nav3 = clientNav.filter(
      (item: object) => getValue(item, `name`, "") === selectedDynamicTabKey,
    );
    // if (!getValue(localStorage, `d_key`, "")) {
    //   localStorage.setItem("d_key", getValue(nav2, `[${0}].name`, ""));
    //   setSelectedDynamicTabKey(getValue(nav2, `[${0}].name`, ""));
    // }
    setClientNavigation([...nav1, ...nav3]);
    setClientMoreNavigation(nav2);
    setIsLoading(false);
  }, [props.permissions]);

  const [isMenuActive, setMenuActive] = useState(false);
  useEffect(() => {
    const { isOpenFirstLevel, isOpenSecondLevel } = props;
    const activePaths = {
      firstLevel: isOpenFirstLevel,
      secondLevel: isOpenSecondLevel,
    };
    clientNavigation.some((item: any, firstIndex: any) => {
      if (
        getValue(item, `menu.length`, 0) > 0 &&
        getValue(item, `menu`, []).some((submenu: any, secondIndex: any) => {
          if (
            window.location.pathname.startsWith(submenu.link) ||
            submenu.childrens?.some(
              (child: any) => window.location.pathname === child.link,
            )
          ) {
            activePaths.firstLevel = firstIndex;
            activePaths.secondLevel = secondIndex;
            return true; // break the loop
          }
          return false;
        })
      ) {
        return true; // break the loop
      }
      return false;
    });
    if (isMenuActive) {
      setIsOpenFirstLevel(null);
      setIsOpenSecondLevel(null);
      // setMenuActive(false)
    } else {
      setIsOpenFirstLevel(activePaths.firstLevel);
      setIsOpenSecondLevel(activePaths.secondLevel);
      setMenuActive(false);
    }
  }, [clientNavigation, location.pathname, isMenuActive]);

  const handleDynamicTab = (name: string) => {
    localStorage.setItem("d_key", name);
    let url = location.href;
    localStorage.setItem("url", url);

    setSelectedDynamicTabKey(name);
    const clientNav = optimizeNavigationMenus(
      allNavigationMenu,
      props.permissions,
      props.subTabPermissionList,
    );
    let mainNav = clientNav.filter(
      (item: object) => getValue(item, `name`, "") !== name,
    );
    let clientDynamicNav = clientNav.filter(
      (item: object) => getValue(item, `name`, "") === name,
    );
    setDynamicNavigation([...mainNav, ...clientDynamicNav]);
  };
  return (
    <>
      <Header
        setIsOpenFirstLevel={setIsOpenFirstLevel}
        setIsOpenSecondLevel={setIsOpenSecondLevel}
        setMenuActive={setMenuActive}
      />
      <section
        className={`main-wrapper ${
          isOpenSecondLevel ||
          isOpenSecondLevel ||
          isOpenSecondLevel === 0 ||
          isOpenSecondLevel === 0
            ? "sidebar-isOpen"
            : ""
        }`}
      >
        <div className="main-user-wrapper">
          <LeftNavigation
            permissions={getValue(props, `permissions`, [])}
            subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
            isOpenFirstLevel={isOpenFirstLevel}
            isOpenSecondLevel={isOpenSecondLevel}
            toggleFirstLevel={toggleFirstLevel}
            toggleSecondLevel={toggleSecondLevel}
            setIsOpenFirstLevel={setIsOpenFirstLevel}
            setIsOpenSecondLevel={setIsOpenSecondLevel}
            clientNavigation={clientNavigation}
            clientMoreNavigation={clientMoreNavigation}
            dynamicNavigation={dynamicNavigation}
            selectedDynamicTab={selectedDynamicTab}
            handleDynamicTab={handleDynamicTab}
            setMenuActive={setMenuActive}
          />
        </div>
        <div className="dashboard-wrapper">
          {props.children}{" "}
          {/* <div className="footer-container">
						<p><b>Powered by AscentHR</b></p>
					</div> */}
        </div>
      </section>
      {/* <div className="footer-container">
        <p>Powered By Ascent</p>
		Copyright © 2023 Ascent
			</div> */}
    </>
  );
}
